/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Rule } from "../../../models/rule";
import { RuleCondition, Operator } from "../../../models/rule-condition";
import { TagInstance } from "../../../models/tag-instance";
import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: 'app-tag-parameter-editor',
  templateUrl: './tag-parameter-editor.component.html'
})
export class TagParameterEditorComponent implements OnInit {
  
    @Input()
    mRule: Rule;   
    
    @Input()
    mRuleCondition: RuleCondition;
  
    @Input()
    mUniqueIndex: number;

    tag: TagInstance;
    
    mAvailableOperators: Operator[] = [];
    
    mShowBody: boolean = false;
  
    ngOnInit(): void {
        this.mAvailableOperators = [ Operator.EQUAL, Operator.NOT_EQUAL ];
        this.mShowBody = this.mRuleCondition != null && this.mRuleCondition.id != null ? false : true;
    }

    getEntityLabel(): string {
        return this.tag != null ? this.tag.name : "?";
    }

    getValueLabel(): string {
        return this.mRuleCondition.value;
    }
    
    getOperatorLabel(operator: Operator): string {
        if (operator != null) {
            switch (operator) {
                case Operator.EQUAL:
                    return "is";
                case Operator.NOT_EQUAL:
                    return "is not";
            }
        }
    }

    getParameterLabel(): string {
        if (this.mRule != null && this.mRule.event != null && this.mRule.event.properties != null) {
            const property = this.mRule.event.properties.find(property => property.property == this.mRuleCondition.property);
            
            return property != null ? property.name : "?";
        }
        else {
            return "?";
        }
    }
    
    onHide(event, value): void {
        console.log(value);   
    }
    
    onRemove(condition: RuleCondition): void {
        const index = this.mRule.conditions.indexOf(condition);
        
        if (index > -1) {
            this.mRule.conditions.splice(index, 1);
        }
    }
}
